module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-100.cdc3efd5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Slot/images/slot-100.png
// module id = 3363
// module chunks = 11